/**
 * Determines if CPF-based signup should be applied.
 * Based on Bifrost logic: !path.includes('/b2b/') && app_id !== 'mrbig'
 *
 * @param path - The current path
 * @param appId - The app_id query parameter (optional)
 * @returns true if CPF-based signup should be applied
 */
export function shouldApplyCPFBasedSignup(path: string, appId?: string | null): boolean {
  const isB2B = path.includes('/b2b/')
  const isMrbig = appId === 'mrbig'
  return !isB2B && !isMrbig
}
